import { render, staticRenderFns } from "./ProductOrderConfirmation.vue?vue&type=template&id=5d3e6fe0&scoped=true&"
import script from "./ProductOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./ProductOrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderConfirmation.vue?vue&type=style&index=0&id=5d3e6fe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e6fe0",
  null
  
)

export default component.exports